import React from 'react';
import type {
    TileableModel,
    TileViewModel,
} from '@rocco/ui/tile-shared/view-models/tile';
import { CategoryPageTileWithAdminActions } from '~/ui-rocco/pages/category-page/CategoryPageTileWithAdminActions';

interface SearchPageTileProps {
    tile: TileViewModel<TileableModel>;
}

/**
 * Renders a single tile within the search results grid, potentially including admin actions.
 */
export const SearchPageTile: React.FC<SearchPageTileProps> = ({ tile }) => {
    return <CategoryPageTileWithAdminActions tile={tile} />;
};
